import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import axios from 'axios';
import Constant from '../Components/Utils/Constant';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CreateAffiliateform({ onClose }) {
    const [isVisible, setIsVisible] = useState(true);
    const [email, setEmail] = useState("");
    const [name, setName] = useState('');
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState('');
    const [address, setAddress] = useState('');
    const [proffesion, setProffesion] = useState('');
    const [gst, setGst] = useState("");
    const [companyname, setCompanyname] = useState('');
    const [createdby, setCreatedby] = useState('');
    const [affiliateName, setAffiliateName] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [isGstValid, setIsGstValid] = useState(true);
    const [togglePassword, setTogglePassword] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [dob, setDob] = useState(''); // FIX: Changed state name from 'date' to 'dob'

    useEffect(() => {
        const storedName = localStorage.getItem("name");

        if (storedName) {
            setAffiliateName(storedName);
            setCreatedby(storedName);
        } else {
            setAffiliateName("Unauthorized");
            setCreatedby("Unauthorized");
        }
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    };

    const validateGst = (gst) => {
        if (gst.trim() === "") return true;
        const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}\d{1}$/;
        return gstRegex.test(gst) && gst.length === 15;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${month}/${day}/${year}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim() || !phone.trim() || !email.trim() || !password.trim() || !proffesion) {
            toast.error("Please fill all required fields: Name, Phone, Email, Password, and Profession.");
            return;
        }

        const isEmailValid = validateEmail(email);
        const isPhoneValid = validatePhone(phone);
        const isGstValid = validateGst(gst);
        setIsEmailValid(isEmailValid);
        setIsPhoneValid(isPhoneValid);
        setIsGstValid(isGstValid);

        if (isEmailValid && isPhoneValid && isGstValid) {
            try {
                const affiliateData = {
                    email,
                    name,
                    phone,
                    password,
                    dob: formatDate(dob), // FIX: Send 'dob' instead of 'date'
                    address,
                    proffesion,
                    gst,
                    companyname,
                    createdby,
                };
                const response = await axios.post(`${Constant.BASE_URL}/affiliate/signup`, affiliateData);
                if (response.status === 201) {
                    setEmail('');
                    setAddress('');
                    setCompanyname('');
                    setDob(''); // FIX: Reset 'dob' state
                    setName('');
                    setPassword('');
                    setProffesion('');
                    setPhone('');
                    setGst('');
                    console.log('response', response);
                    toast.success("Affiliate created successfully");


                    setTimeout(() => {
                        handleClose();
                    }, 3000);
                } else {
                    console.log("Failed to submit form. Status:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    return isVisible ? (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="popup-form">
                <div className="w-full  flex items-center justify-center">
                    <div className="bg-white p-4 rounded-md shadow-md  py-3 px-1   w-fit">
                        <div className="lg:w-[600px] xl:w-[630px] 2xl:w-[1300px] items-center justify-center">
                            <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl 2xl:py-3">
                                Create Affiliate
                            </div>
                            <hr className="mt-1 " />

                            <form onSubmit={handleSubmit}>
                                <div className="flex items-center justify-center lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                    <div className="pr-3 border-r ">
                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className=" flex items-center px-3 "
                                            >
                                                Name :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="name"
                                                className="border-b border-gray-500 outline-none createuserline"
                                                placeholder="name"
                                                value={name} onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Phone :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="flex flex-col">
                                                <input
                                                    type="tel"
                                                    id="phone"
                                                    name="phone"
                                                    className="border-b border-gray-500 outline-none  createuserline"

                                                    value={phone} onChange={(e) => setPhone(e.target.value)}
                                                    placeholder="number"
                                                    required
                                                />
                                                {!isPhoneValid && (
                                                    <p className="text-red-500">
                                                        Invalid phone format (10 digits)
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label
                                                htmlFor="yourInput"
                                                className="flex items-end px-3"
                                            >
                                                Email :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="flex flex-col">
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    className="border-b border-gray-500 outline-none  createuserline"
                                                    // style={{ width: "163px", textAlign: "center" }}
                                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="email"
                                                    required
                                                />
                                                {!isEmailValid && (
                                                    <p className="text-red-500 ml-1">
                                                        Invalid email format
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className="mb-1 flex items-center px-3"
                                            >
                                                Password :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type={togglePassword ? "text" : "password"}
                                                id="password"
                                                className="border-b border-gray-500 outline-none createuserline"
                                                placeholder="....."
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                            <span onClick={() => {
                                                setTogglePassword(!togglePassword)
                                            }} className="absolute inset-y-0 lg:top-[40px] xl:top-[40px] 2xl:top-[65px] flex items-center pr-2">
                                                {
                                                    togglePassword ?
                                                        <div className="" >
                                                            <IoEye className='text-1xl' />
                                                        </div>
                                                        :
                                                        <div className=''>
                                                            <RiEyeCloseLine className="text-1xl" />
                                                        </div>
                                                }
                                            </span>
                                        </div>
                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className="mb-1 flex items-center px-3"
                                            >
                                                Company Name :

                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none createuserline"
                                                placeholder="company name"
                                                value={companyname} onChange={(e) => setCompanyname(e.target.value)}

                                            />
                                        </div>
                                    </div>

                                    {/* Date started  */}

                                    <div className="w-fit py-4 pl-1 pr-2 flex-col">
                                        <div className="flex pb-3 text-gray-500 relative justify-end">
                                            <label
                                                htmlFor="date"
                                                className="mb-1 text-gray-900  flex items-center px-3"
                                            >
                                                Date of Birth:

                                            </label>
                                            <input
                                                type="date"
                                                id="date"                                                className="border-b border-gray-500 outline-none createuserline"
                                                value={dob} // FIX: Use 'dob' state
                                                onChange={(e) => setDob(e.target.value)} // FIX: Update 'dob' state
                                                max={new Date().toISOString().split("T")[0]}

                                            />
                                        </div>

                                        {/* Date ended  */}

                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className="mb-1 flex items-center px-3"
                                            >
                                                Address :
                                            </label>
                                            <input
                                                type="text"
                                                id="address"
                                                className="border-b border-gray-500 outline-none createuserline"
                                                value={address} onChange={(e) => setAddress(e.target.value)}
                                                placeholder="address"

                                            />
                                        </div>

                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourSelect"
                                                className=" mb-1 flex items-center px-3"
                                            >
                                                Profession :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="text-center relative">
                                                <select
                                                    id="proffesion"
                                                    className="   border-b border-gray-500 appearance-none outline-none createuserline"
                                                    style={{ color: "#BBB " }}
                                                    value={proffesion} onChange={(e) => setProffesion(e.target.value)}

                                                    required
                                                >
                                                    <option value="" disabled selected>
                                                        proffesion{" "}
                                                    </option>
                                                    <option value="Fabric Manufacturer">
                                                        Fabric Manufacturer
                                                    </option>
                                                    <option value="Garment Manufacturer">
                                                        Garment Manufacturer
                                                    </option>
                                                    <option value="Yarn Manufacturer">
                                                        Yarn Manufacturer
                                                    </option>
                                                    <option value="Trader & Broker">
                                                        Trader & Broker
                                                    </option>
                                                    <option value="Buyer">Buyer</option>
                                                    <option value=">Designer">Designer</option>
                                                    <option value="Finisher">Finisher</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <span className="absolute inset-y-0 right-0 flex items-center  pointer-events-none">
                                                    <div className="bg-white shadow-md border border-white mb-2">
                                                        <MdArrowDropDown className="text-1xl" />
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className="mb-1 flex items-center px-3"
                                            >
                                                GST Number :
                                            </label>
                                            <div className="flex flex-col">
                                                <input
                                                    type="text"
                                                    id="gst"
                                                    className={`border-b border-gray-500 outline-none createuserline ${gst.length > 0 && !isGstValid ? "border-red-500" : ""}`}
                                                    value={gst}
                                                    onChange={(e) => setGst(e.target.value)}
                                                    placeholder="gstnumber"
                                                />
                                                {/* {gst.length > 0 && !isGstValid && (
                                                    <p className="text-red-500">
                                                        Invalid GST number
                                                    </p>
                                                )} */}
                                            </div>
                                        </div>
                                        <div className="flex py-3 text-gray-500 justify-end">
                                            <label
                                                htmlFor="yourInput"
                                                className="mb-1 text-gray-900 flex items-center px-3"
                                            >
                                                Created By :
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className=" text-[#BBB] border-b border-gray-500 outline-none createuserline"
                                                value={affiliateName}
                                                onChange={(e) => setCreatedby(e.target.affiliateName)}
                                                placeholder="Super Admin (Login Detect)"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 lg:pt-10 xl:pt-10 2xl:pt-10
                                            lg:text-[10px] xl:text-[13px] 2xl:text-[30px]">
                                    <button
                                        type="button"
                                        onClick={handleClose}
                                        className=" bg-white rounded-sm px-3 py-1 flex-shrink-0 shadow-md"
                                        style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-3 rounded-sm  py-1 flex-shrink-0 "
                                        style={{
                                            background:
                                                "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                        }}
                                    >
                                        Create
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : null;
}

